import Enum from "../../../../enums/Enum";

const TeleconsultationFormTextEnum = new Enum({
    Teleconsultation_Consent_Form_Title: { English: "TELECONSULTATION CONSENT FORM", Arabic: "نموذج موافقة الاستشارة عن بعد" },
    Teleconsultation_Consent_Form_Header: { English: "Teleconsultation Consent Form", Arabic: "نموذج موافقة الاستشارة عن بعد" },

    Patient_Information: { English: "Patient information:", Arabic: "معلومات المريض:" },
    Name: { English: "Name:", Arabic: "الاسم:" },
    MRN: { English: "MRN:", Arabic: "رقم السجل الطبي:" },
    DOB: { English: "D.O.B:", Arabic: "تاريخ الميلاد:" },

    Treatment_Consideration: {
        English: "It is important for you to consider the benefits, risks and alternatives to the teleconsultation treatment offered by our licensed healthcare professionals in order to make an informed decision about proceeding with treatment. Teleconsultation services include online clinical evaluation of your illness/injury, clinical recommendation on treatment and diagnostic tests, evaluation of results, suggested treatment plan and a medical report of the recommendations to your treating healthcare provider. To be able to provide you these services, we would like to obtain your consent to access your medical records & have a live audio and video interaction.",
        Arabic: "من المهم أن تفكر في الفوائد والمخاطر والبدائل للعلاج عن بعد الذي يقدمه استشاري طب الأسرة أو أخصائي الطب الرياضي أو أخصائي الطب الفيزيائي وإعادة التأهيل من أجل اتخاذ قرار مستنير بشأن المضي قدمًا في العلاج. تتضمن خدمات الاستشارة عن بعد التقييم السريري عبر الإنترنت لمرضك/إصابتك، والتوصية السريرية بشأن العلاج والاختبارات التشخيصية، وتقييم النتائج، وخطة العلاج المقترحة، وتقرير طبي (من قبل الطبيب) بالتوصيات لمقدم الرعاية الصحية المعالج لك. لكي نتمكن من تقديم هذه الخدمات لك، نود الحصول على موافقتك للوصول إلى سجلاتك الطبية وإجراء تفاعل صوتي و/أو مرئي مباشر"
    },

    Electronic_Systems: { English: "Electronic systems:", Arabic: "الأنظمة الإلكترونية:" },
    Electronic_Systems_Description: {
        English: "Electronic systems used will incorporate network and software security protocols to protect confidentiality of patient identification and imaging data and will include measures to safeguard the data and to ensure its integrity against intentional and unintentional corruption in accordance with the Laws and Regulations.",
        Arabic: "ستتضمن الأنظمة الإلكترونية المستخدمة بروتوكولات أمان الشبكة والبرمجيات لحماية سرية بيانات هوية المريض والتصوير، وستتضمن تدابير لحماية البيانات وضمان سلامتها ضد الفساد المتعمد وغير المتعمد وفقًا لقوانين وأنظمة دولة الإمارات العربية المتحدة."
    },

    Nature_Of_Teleconsultation: { English: "Nature of Teleconsultation:", Arabic: "طبيعة الاستشارة عن بعد:" },
    Nature_Of_Teleconsultation_Description: {
        English: "During the teleconsultation",
        Arabic: "أثناء الاستشارة عن بعد"
    },

    Nature_Of_Teleconsultation_Point1: {
        English: "Details of your medical history, examinations, x-rays and tests may be discussed with other healthcare professionals with interactive videos, audio and telecommunication technology.",
        Arabic: "قد تتم مناقشة تفاصيل تاريخك الطبي والفحوصات والأشعة السينية والاختبارات مع متخصصين آخرين في الرعاية الصحية من خلال مقاطع فيديو تفاعلية وتقنية صوتية واتصالات."
    },

    Nature_Of_Teleconsultation_Point2: {
        English: "Upon your approval, audio and/or photo recordings may be taken for accurate diagnosis, treatment and quality control.",
        Arabic: "بعد الحصول على موافقتك، قد يتم أخذ تسجيلات صوتية و/أو صورية للتشخيص الدقيق والعلاج ومراقبة الجودة."
    },

    Medical_Information_And_Records: { English: "Medical Information and Records:", Arabic: "المعلومات والسجلات الطبية:" },
    Medical_Information_Description: {
        English: "All existing federal laws and local regulations/policies/guidelines regarding access to medical information and copies of your Health Records apply to this teleconsultation. Dissemination of any patient identifiable images or information for this telehealth interaction to other entities will not take place    without your consent.",
        Arabic: "تنطبق على هذه الاستشارة عن بعد جميع القوانين الفيدرالية واللوائح/السياسات/المبادئ التوجيهية المحلية الحالية فيما يتعلق بالوصول إلى المعلومات الطبية ونسخ من سجلاتك الصحية. لن يتم نشر أي صور أو معلومات يمكن التعرف على هوية المريض من خلالها فيما يتعلق بهذا التفاعل عن بعد مع جهات أخرى دون موافقتك."
    },

    Confidentiality: { English: "Confidentiality:", Arabic: "السرية:" },
    Confidentiality_Description: {
        English: "Responsible and appropriate efforts have been made to eliminate any confidentiality risks associated with the teleconsultation and all existing confidentiality protections under the federal laws and     local regulation apply to information disclosed during this teleconsultation.",
        Arabic: "تم بذل جهود مناسبة للقضاء على أي مخاطر تتعلق بالسرية المرتبطة بالاستشارة عن بعد، وتنطبق جميع تدابير حماية السرية الحالية بموجب القوانين الاتحادية لدولة الإمارات العربية المتحدة واللوائح المحلية على المعلومات التي تم الكشف عنها أثناء هذه الاستشارة عن بعد."
    },

    Rights: { English: "Rights:", Arabic: "الحقوق:" },
    Rights_Description: {
        English: "You may withhold or withdraw consent to teleconsultation at any time without affecting your right to future care or treatment. You will be advised of all the risks, consequences and benefits of teleconsultation. Your treating physician will discuss with you the information provided in a language you can understand. You will be given the opportunity to ask questions about the information presented in this form and about the teleconsultation. ",
        Arabic: "يمكنك حجب أو سحب موافقتك على الاستشارة عن بُعد في أي وقت دون المساس بحقك في الرعاية أو العلاج مستقبلاً. سيتم إبلاغك بجميع مخاطر وعواقب وفوائد الاستشارة عن بُعد. سيناقش طبيبك المعالج معك المعلومات المُقدمة بلغة تفهمها. ستتاح لك فرصة طرح الأسئلة حول المعلومات الواردة في هذا النموذج وحول الاستشارة عن بُعد."
    },

    Expected_Benefits: { English: "Expected Benefits:", Arabic: "الفوائد المتوقعة:" },
    Expected_Benefits_Point1: {
        English: "Improve access to medical care by enabling a patient to remain in their home, office (or a remote site) while your licensed healthcare provider offers you the needed care.",
        Arabic: "تحسين الوصول إلى الرعاية الطبية من خلال تمكينك من البقاء في منزلك أو مكتبك (أو موقع بعيد) بينما يقدم لك مقدم الرعاية الصحية المرخص من هيئة الصحة بدبي، الرعاية اللازمة."
    },
    Expected_Benefits_Point2: {
        English: "More efficient medical evaluation and management.",
        Arabic: "تقييم وإدارة طبية بطريقة فعالة أكثر."
    },

    Possible_Risks: { English: "Possible Risks:", Arabic: "المخاطر المحتملة:" },
    Possible_Risks_Description: {
        English: "As with any medical procedures there are potential risks associated with the use of Telehealth, which may include, but not limited to the following:",
        Arabic: "كما هو الحال مع أي إجراءات طبية، هناك مخاطر محتملة مرتبطة باستخدام التطبيب عن بعد، والتي قد تشمل، على سبيل المثال لا الحصر، ما يلي:"
    },

    Possible_Risks_Point1: {
        English: "Information transmission may not be sufficient (e.g. poor resolution of images) to allow appropriate decision making by the consulted physician.",
        Arabic: "قد لا يكون نقل المعلومات كافياً (على سبيل المثال، ضعف دقة الصور) للسماح باتخاذ القرار المناسب من قبل الطبيب الذي يتم استشارته."
    },
    Possible_Risks_Point2: {
        English: "Delays in medical evaluation and treatment could occur due to deficiencies or failure of internet.",
        Arabic: "قد يحدث تأخير في التقييم الطبي والعلاج بسبب أوجه القصور أو فشل الإنترنت."
    },
    Possible_Risks_Point3: {
        English: "In rare instances, security protocol could fail causing a breach of privacy of personal medical information.",
        Arabic: "في حالات نادرة، قد يفشل بروتوكول الأمان مما يتسبب في خرق خصوصية المعلومات الطبية الشخصية."
    },
    Possible_Risks_Point4: {
        English: "In rare cases, a lack of access to complete health records may result in adverse drug interactions, allergic reactions, or other judgement errors.",
        Arabic: "في حالات نادرة، قد يؤدي عدم القدرة على الوصول إلى السجلات الصحية الكاملة إلى تفاعلات دوائية ضارة أو تفاعلات حساسية أو أخطاء أخرى في الحكم."
    },

    Questions_And_Concerns: { English: "Questions of concerns:", Arabic: "الأسئلة:" },
    Questions_And_Concerns_Section1_Description: {
        English: "You are encouraged to ask questions at any time regarding your assessment and treatment. Bring any concerns you have to your Doctor or Therapist’s attention. If you are not comfortable, you may stop treatment at any time. You have the right to have your concerns heard and resolved when possible.",
        Arabic: "نشجعك على طرح الأسئلة في أي وقت بخصوص تقييمك وعلاجك. احضر أي مخاوف لديك إلى انتباه طبيبك. إذا لم تكن مرتاحًا، يمكنك إيقاف العلاج في أي وقت. لديك الحق في أن يتم الاستماع إلى مخاوفك وحلها عندما يكون ذلك ممكنًا."
    },

    Questions_And_Concerns_Section1_Point1: {
        English: "I understand that I have chosen to engage in a video consultation with the purpose of assessing and treating my medical condition and/or obtaining general medical advice.",
        Arabic: "أفهم أنني اخترت المشاركة في استشارة فيديو بغرض تقييم حالتي الطبية وعلاجها و/أو الحصول على مشورة طبية عامة."
    },

    Questions_And_Concerns_Section1_Point2: {
        English: "I confirm that I understand how video consultation technology will be used and this consultation will not be the same as a direct patient/healthcare provider visit since I will not be in the same room as my healthcare provider, hence, they must rely on information provided by me or my onsite healthcare providers.",
        Arabic: "أؤكد أنني أفهم كيف سيتم استخدام تقنية استشارة الفيديو وأن هذه الاستشارة لن تكون مثل زيارة مباشرة للمريض/مقدم الرعاية الصحية حيث لن أكون في نفس الغرفة مع مقدم الرعاية الصحية الخاص بي، وبالتالي، يجب عليهم الاعتماد على المعلومات المقدمة مني أو من مقدمي الرعاية الصحية في الموقع."
    },

    Questions_And_Concerns_Section1_Point3: {
        English: "I understand that I may benefit from teleconsultation, but that results cannot be guaranteed or assured. Additionally, I understand that teleconsultation services and care may not be as complete as in-person services. I also understand that if the teleconsultation doctor believes I would be better served by an in-person consultation, I will be asked to visit a clinic, hospital, or specialist who can provide such services in my area.",
        Arabic: "أفهم أنني قد أستفيد من الاستشارة عن بعد، ولكن لا يمكن ضمان النتائج أو تأكيدها. بالإضافة إلى ذلك، أفهم أن خدمات الاستشارة عن بعد والرعاية قد لا تكون كاملة مثل الخدمات الشخصية. أفهم أيضًا أنه إذا اعتقد طبيب الاستشارة عن بعد أنني سأستفيد بشكل أفضل من الاستشارة الشخصية، فسوف يُطلب مني زيارة عيادة أو مستشفى أو أخصائي يمكنه تقديم مثل هذه الخدمات في منطقتي."
    },

    Questions_And_Concerns_Section2_Description: {
        English: "DISC doctors cannot be responsible for advice, recommendations and/or decisions based on incomplete or inaccurate information provided by me or others.",
        Arabic: "لا يمكن لأطباء DISC أن يكونوا مسؤولين عن النصائح والتوصيات و/أو القرارات المبنية على معلومات غير كاملة أو غير دقيقة قدمتها أنا أو غيري"
    },

    Questions_And_Concerns_Section2_Point1: {
        English: "I understand and I am aware of the alternative treatment options available to me, and I am choosing to participate in a video consultation.",
        Arabic: "أفهم وأدرك خيارات العلاج البديلة المتاحة لي، وأختار المشاركة في استشارة فيديو."
    },

    Questions_And_Concerns_Section2_Point2: {
        English: "I understand that the service is not intended for emergency consultations, and I am aware that I need to contact local emergency services in case of any doubt. In an emergency, I understand that it is my responsibility to seek advice from my local practitioner, and that the teleconsultation provider’s responsibility will conclude upon the termination of the video conference.",
        Arabic: "أفهم أن الخدمة غير مخصصة للاستشارات الطارئة وأدرك أنني بحاجة إلى الاتصال بخدمات الطوارئ المحلية في حالة وجود أي شك. في حالة الطوارئ، أفهم أنه من مسؤوليتي إبلاغ طبيبي المحلي وأن مسؤولية مقدم الاستشارة عن بعد ستنتهي عند انتهاء مؤتمر الفيديو."
    },

    Questions_And_Concerns_Section2_Point3: {
        English: "In order to maintain patient-doctor confidentiality I shall under no circumstance record and/or distribute the link or the content of my telehealth consultation to any persons whatsoever.",
        Arabic: "من أجل الحفاظ على سرية العلاقة بين المريض والطبيب، لن أقوم تحت أي ظرف من الظروف بتسجيل و/أو توزيع رابط أو محتوى استشارتي عن بعد لأي شخص مهما كان."
    },

    Questions_And_Concerns_Section2_Point4: {
        English: "I understand that I may withhold or withdraw consent to teleconsultation at any time without affecting my right to future care or treatment.",
        Arabic: "أفهم أنه يجوز لي سحب الموافقة على الاستشارة عن بعد في أي وقت دون التأثير على حقي في الرعاية أو العلاج في المستقبل."
    },

    Questions_And_Concerns_Section2_Point5: {
        English: "I agree that any disputes that arise from the teleconsultation will be resolved as per the laws and regulations and will be raised with the telehealth provider in the first instance.",
        Arabic: "أوافق على أن أي نزاعات تنشأ عن الاستشارة عن بعد سيتم حلها وفقًا لقوانين وأنظمة دولة الإمارات العربية المتحدة وسيتم رفعها إلى مقدم الرعاية الصحية عن بعد في المقام الأول."
    },

    Questions_And_Concerns_Section3_Description: {
        English: "By signing this consent and beginning the video consultation, I certify that:",
        Arabic: "من خلال التوقيع على هذه الموافقة وبدء الاستشارة عبر الفيديو، أقر بأنني:"
    },

    Questions_And_Concerns_Section3_Point1: {
        English: "I have read or had this form read and/or had this form explained to me.",
        Arabic: "قرأت هذا النموذج أو طلبت قراءة هذا النموذج و/أو تم شرحه لي."
    },

    Questions_And_Concerns_Section3_Point2: {
        English: "I fully understand its contents including the risks and benefits of using the service.",
        Arabic: "أفهم محتوياته بالكامل بما في ذلك المخاطر والفوائد المترتبة على استخدام الخدمة."
    },

    Questions_And_Concerns_Section3_Point3: {
        English: "I have been given ample opportunity to ask questions and that any questions have been answered to my satisfaction.",
        Arabic: "أتيحت لي الفرصة الكافية لطرح الأسئلة وأن أي أسئلة تمت الإجابة عليها على النحو الذي يرضيني."
    },

    Questions_And_Concerns_Section3_Point4: {
        English: "I freely give my informed consent and volunteer to engage in this telemedicine consultation.",
        Arabic: "أعطي موافقتي المستنيرة بحرية وأتطوع للمشاركة في استشارة الطب عن بعد هذه."
    },

    Final_Consent_Statement: {
        English: "I hereby acknowledge I understand and consent to receiving care from a Healthcare Provider who is of a different Gender than myself. I consent voluntarily and grant the Healthcare Provider permission to provide the treatment or procedure and understand that I have the right to withdraw from the procedure or treatment at any time without in any way affecting my medical care.",
        Arabic: "أقرّ بموجب هذا بأنني أفهم وأوافق على تلقي الرعاية من مقدم رعاية صحية من جنس مختلف عن جنسّي. أوافق طوعًا وأمنح مقدم الرعاية الصحية الإذن بتقديم العلاج أو الإجراء، وأفهم أن لي الحق في الانسحاب من الإجراء أو العلاج في أي وقت دون أي تأثير على رعايتي الطبية."
    },

    Yes: { English: "Yes", Arabic: "نعم" },
    No: { English: "No", Arabic: "لا" },

    Date: {English: "Date", Arabic: "التاريخ"},
    Patient_Name: {English: "Patient Name", Arabic: "اسم المريض"},
    Patient_Signature: {
        English: "Signature of Patient (or legal guardian)",
        Arabic: "توقيع المريض (أو الوصي)"
    },

    Witness_Statement: {
        English: "I have accurately read or witnessed the accurate reading of the consent form to the potential patient, and the individual has had the opportunity to ask questions. I confirm that the individual has given consent freely.",
        Arabic: "لقد قرأت بدقة أو شهدت القراءة الدقيقة لنموذج الموافقة للمريض المحتمل، وأتيحت للفرد الفرصة لطرح الأسئلة. أؤكد أن الفرد قد أعطى موافقته بحرية"
    },

    Print_Name: {
        English: "Legal Guardian Name",
        Arabic: "اسم الوصي"
    },
    Official_Use_Only: {
        English: "FOR OFFICIAL USE ONLY",
        Arabic: "للاستخدام الرسمي فقط"
    },
    Witness_Statement_Header: {
        English: "Witness Statement",
        Arabic: "بيان الشاهد"
    },
    Witness_Name: {
        English: "Name of Witness",
        Arabic: "اسم الشاهد"
    },
    Witness_Signature: {
        English: "Witness Signature",
        Arabic: "توقيع الشاهد"
    },
    Provider_Name: {English: "Provider's name", Arabic: "اسم مقدم الرعاية الصحية"},
    Provider_Signature: {English: "Signature of Provider", Arabic: "توقيع مقدم الرعاية الصحية"},
    Relationship_To_Patient: {English: "Relationship to Patient", Arabic: "العلاقة بالمريض"},

    Agree: { English: "agree", Arabic: "أوافق" },
    Refuse: { English: "refuse", Arabic: "أرفض" },

    Previous: { English: "Previous", Arabic: "السابق" },
    Next: { English: "Next", Arabic: "التالي" },
    Save: { English: "Save", Arabic: "حفظ" },
    Clear: {English: "Clear", Arabic: "مسح"},

    Signature_Required: {English: "Signature Required", Arabic: "التوقيع مطلوب"},
    Field_Required: {English: "Field cannot be left blank", Arabic: "لا يمكن ترك الحقل فارغًا"},
});

export default TeleconsultationFormTextEnum; 